import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import { getDefaultState } from '@/store/plugins/localStoragePlugin'
import breaks from '@/store/modules/service/breaks'
import rounds from '@/store/modules/service/rounds'

export default {
  namespaced: true,
  state: getDefaultState(
    'service',
    {
      active: null,
      rondeActive: null
    }
  ),
  actions: {
    ...actions,
    ...breaks.actions,
    ...rounds.actions
  },
  mutations: {
    ...mutations,
    ...breaks.mutations,
    ...rounds.mutations
  },
  getters: {
    ...getters,
    ...breaks.getters,
    ...rounds.getters
  }
}
